import EmblaCarousel from "embla-carousel";

class ImageGalleryElement extends HTMLElement {
  connectedCallback() {
    const viewportNode = this.querySelector(".embla__viewport");
    this.emblaApi = EmblaCarousel(viewportNode, { loop: true });
    viewportNode.style.cursor = "grab";
    this.emblaApi.on("pointerdown", () => {
      viewportNode.style.cursor = "grabbing";
    });
    this.emblaApi.on("pointerup", () => {
      viewportNode.style.cursor = "grab";
    });
    const captionContainerNode = this.querySelector(".embla__caption");
    const captionNodes = Array.from(this.querySelectorAll("figcaption"));
    const dotNodes = Array.from(this.querySelectorAll(".embla__dot"));
    for (let i = 0; i < dotNodes.length; i++) {
      dotNodes[i].addEventListener("click", () => this.emblaApi.goTo(i), false);
    }
    this.emblaApi.on("select", () => {
      if (!dotNodes.length) return;
      const previous = this.emblaApi.previousSnap();
      const selected = this.emblaApi.selectedSnap();
      dotNodes[previous].classList.remove("embla__dot--selected");
      dotNodes[selected].classList.add("embla__dot--selected");
      if (captionContainerNode) {
        captionContainerNode.innerHTML = captionNodes[selected].innerHTML;
      }
    });
  }

  disconnectedCallback() {
    this.emblaApi.destroy();
  }
}

customElements.define("image-gallery", ImageGalleryElement);
